import "../button/btn.css"

import classNames from "classnames"
import React, { forwardRef } from "react"

import { BaseLink, BaseLinkElementProps } from "./BaseLink"

export type IconLinkProps = Omit<BaseLinkElementProps, "label" | "children"> & {
  "aria-label": string
  /** The icon element to display. */
  icon: React.ReactNode
}

/**
 * An icon-only link component that renders as an HTML `<a>` element with
 * button-like styling. Requires an `icon` and `aria-label` for accessibility.
 *
 * @component
 * @see {@link https://planningcenter.github.io/tapestry/?path=/docs/components-link-icon-link--docs | Storybook Documentation}
 */
export const IconLink = forwardRef<HTMLAnchorElement, IconLinkProps>(
  ({ className, href, icon, ...restProps }: IconLinkProps, ref) => {
    const iconOnlyClassName = classNames("tds-btn--icononly", className)

    return (
      <BaseLink
        href={href}
        label={icon}
        className={iconOnlyClassName}
        ref={ref}
        {...restProps}
      />
    )
  }
)

IconLink.displayName = "IconLink"
